import fetch from "./fetch";
/**
 * 课程管理
 */
const course = {
  //相关推荐枚举
  getCourseRecommend(params) {
    return fetch({
      isLoading: true,
      url: "/v1/course/selectAll",
      method: "GET",
      params,
    });
  },
  //课程分页
  getCourseList(params) {
    return fetch({
      isLoading: true,
      url: "/v1/course/page",
      method: "GET",
      params,
    });
  },
  //删除课程
  deleteCourse(data) {
    return fetch({
      isLoading: true,
      url: "/v1/course/delete",
      method: "POST",
      data,
    });
  },
  //添加课程
  addCourse(data) {
    return fetch({
      isLoading: true,
      url: "/v1/course/save",
      method: "POST",
      data,
    });
  },
  //添加课程
  editCourse(data) {
    return fetch({
      isLoading: true,
      url: "/v1/course/update",
      method: "POST",
      data,
    });
  },
};

export default course;
